<h2 mat-dialog-title [class]="'soph-ai-header' + (loading() ? 'center' : '')">
  <span>SophIA</span>
  @if(!loading()) {
  <button matIconButton mat-dialog-close matRipple>
    <mat-icon>close</mat-icon>
  </button>
  }
</h2>

<mat-dialog-content>
  @if(!loading() && !hasError()) {
  <span>
    Información médica basada en los datos de identificación y anamnesis
  </span>

  <section class="diagnosis">
    <mat-card appearance="outlined">
      <mat-card-header>
        <div>
          <mat-icon>warning</mat-icon>
          <mat-card-title>Diagnóstico Diferencial</mat-card-title>
        </div>
      </mat-card-header>
      <mat-card-content>
        <p>{{ diagnosis()?.diagnostico || "No se encontró información." }}</p>
      </mat-card-content>
    </mat-card>

    <mat-card appearance="outlined">
      <mat-card-header
        ><div>
          <mat-icon>sticky_note_2</mat-icon>
          <mat-card-title>Consideraciones Clínicas</mat-card-title>
        </div>
      </mat-card-header>
      <mat-card-content>
        <p>
          {{ diagnosis()?.consideraciones || "No se encontró información." }}
        </p>
      </mat-card-content>
    </mat-card>

    <mat-card appearance="outlined">
      <mat-card-header>
        <div>
          <mat-icon>monitor_heart</mat-icon>
          <mat-card-title>Exámenes Recomendados</mat-card-title>
        </div>
      </mat-card-header>
      <mat-card-content>
        @if(diagnosis()?.examenes) {
        <ul>
          @for(examen of diagnosis()?.examenes ?? []; track examen) {
          <li>{{ examen }}</li>
          }
        </ul>
        }@else {
        <p>No se encontró información.</p>
        }
      </mat-card-content>
    </mat-card>

    <mat-card appearance="outlined">
      <mat-card-header>
        <div>
          <mat-icon>bolt</mat-icon>
          <mat-card-title>Acciones Inmediatas</mat-card-title>
        </div>
      </mat-card-header>
      <mat-card-content>
        @if(diagnosis()?.acciones_inmediatas) {
        <ol>
          @for(accion of diagnosis()?.acciones_inmediatas ?? []; track accion) {
          <li>{{ accion }}</li>
          }
        </ol>
        } @else {
        <p>No se encontró información.</p>
        }
      </mat-card-content>
    </mat-card>

    <mat-card appearance="outlined">
      <mat-card-header>
        <div>
          <mat-icon>warning</mat-icon>
          <mat-card-title class="disclaimer">
            Descargo de Responsabilidad
          </mat-card-title>
        </div>
      </mat-card-header>
      <mat-card-content>
        <p class="disclaimer-content">
          {{
            diagnosis()?.descargo_de_responsabilidad ||
              "No se encontró información."
          }}
        </p>
      </mat-card-content>
    </mat-card>
  </section>

  } @if(loading()) {
  <div class="loading-container">
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    <p>Generando diagnóstico...</p>
  </div>
  } @if(hasError()) {
  <div class="error-container">
    <p>
      Error al generar diagnóstico. Por favor, inténtelo de nuevo más tarde.
    </p>
  </div>
  }
</mat-dialog-content>
